import TIM from 'tim-js-sdk';

export class GroupManager {
  tim?: TIM.IMClient;
  constructor(tim: TIM.IMClient) {
    this.tim = tim;
  }

  /** 获取群组资料 */
  async getGroupProfile({ groupID }: { groupID: string }) {
    const groupProfile = await this.tim?.getGroupProfile({ groupID: groupID });
    return groupProfile;
  }
}
